export default __webpack_public_path__ + "media/sach_small_white.3215562c.svg";